const styles = theme => ({
  labelFont: {
    marginBottom: theme.spacing.unit * 0.5,
    fontFamily: 'Roboto',
    fontSize: '20px',
    color: 'black',
    lineHeight: '1.5',
    fontWeight: '450'
  },
  emphasizedText: {
    marginBottom: theme.spacing.unit * 0.5,
    fontFamily: 'Roboto',
    fontSize: '24px',
    color: 'black',
    lineHeight: '1.5',
    fontWeight: 'bold'
  },
  boldText: {
    fontWeight: 'bold'
  },
  shiftLeft: {
    marginLeft: '-60px'
  },
  barcodeMargin: {
    padding: '20px 20px 20px 0px !important'
  },
  noMargin: {
    margin: '0px !important'
  },
  carrierLogo: {
    maxWidth: '150px'
  },
  labelTable: {
    width: '100%',
    textAlign: 'left',
    border: '1px solid lightGray',
    background: '#FFFFFF',
    borderSpacing: '0px 5px'
  },
  underline: {
    textDecoration: 'underline'
  },
  uppercase: {
    textTransform: 'uppercase'
  },
  pageBreak: {
    pageBreakAfter: 'always'
  }
});

export default styles;
